const headline = {
  '3xl': {
    font: 'primary',
    size: '66px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  '2xl': {
    font: 'primary',
    size: '46px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  xl: {
    font: 'primary',
    size: '32px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  lg: {
    font: 'primary',
    size: '26px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  md: {
    font: 'primary',
    size: '23px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  sm: {
    font: 'primary',
    size: '20px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  xs: {
    font: 'primary',
    size: '18px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  '2xs': {
    font: 'primary',
    size: '16px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
  '3xs': {
    font: 'primary',
    size: '14px',
    weight: '800',
    leading: '1.2',
    stretch: '80%',
  },
};

const tag = {
  sm: {
    font: 'primary',
    size: '14px',
    weight: '800',
    transform: 'uppercase',
    leading: '1.2',
    stretch: '80%',
  },
};

const preamble = {
  lg: {
    font: 'primary',
    size: '26px',
    leading: '1.5',
    weight: '800',
  },
  md: {
    font: 'primary',
    size: '20px',
    leading: '1.5',
    weight: '800',
  },
  sm: {
    font: 'primary',
    size: '18px',
    leading: '1.5',
    weight: '800',
  },
};

const body = {
  lg: {
    font: 'primary',
    size: '23px',
    leading: '1.5',
    weight: '400',
  },
  md: {
    font: 'primary',
    size: '18px',
    leading: '1.5',
    weight: '400',
  },
  sm: {
    font: 'primary',
    size: '16px',
    leading: '1.5',
    weight: '400',
  },
  xs: {
    font: 'primary',
    size: '14px',
    leading: '1.5',
    weight: '400',
  },
};

const kicker = {
  sm: {
    font: 'primary',
    size: '15px',
    leading: '1.2',
    weight: '400',
  },
};

const input = {
  lg: {
    font: 'primary',
    size: '20px',
    leading: '1.5',
    weight: '400',
  },
  md: {
    font: 'primary',
    size: '16px',
    leading: '1.5',
    weight: '400',
  },
  sm: {
    font: 'primary',
    size: '14px',
    leading: '1.5',
    weight: '400',
  },
  xs: {
    font: 'primary',
    size: '12px',
    leading: '1.5',
    weight: '400',
  },
};

const quote = {
  md: {
    font: 'primary',
    size: '18px',
    weight: '900',
    transform: 'uppercase',
    leading: '1.2',
    stretch: '63%',
  },
  sm: {
    font: 'primary',
    size: '14px',
    weight: '900',
    transform: 'uppercase',
    leading: '1.2',
    stretch: '63%',
  },
};

const typography = {
  headline: {
    DEFAULT: headline.md,
    ...headline,
  },
  tag: {
    DEFAULT: tag.md,
    ...tag,
  },
  preamble: {
    DEFAULT: preamble.md,
    ...preamble,
  },
  body: {
    DEFAULT: body.md,
    ...body,
  },
  kicker: {
    DEFAULT: kicker.sm,
    ...kicker,
  },
  input: {
    DEFAULT: input.md,
    ...input,
  },
  quote: {
    DEFAULT: quote.md,
    ...quote,
  },
};

module.exports = typography;
